import {differenceInDays, differenceInMinutes, isSameDay, isWithinInterval} from 'date-fns';
import {TranslationService} from '../../@types/i18next';

// TODO translations
export const describeMeeting = (
  time: Date,
  startTime: Date,
  endTime: Date,
  t: TranslationService,
): {label: string | null; countdown: string | null; isOngoing: boolean | null} => {
  const dayDiff = differenceInDays(startTime, time);

  // We only describe meetings that are today or tomorrow
  if (dayDiff < 0 || dayDiff > 1) return {label: null, countdown: null, isOngoing: null};

  const timeToStart = differenceInMinutes(startTime, time);
  const isOngoing = isWithinInterval(time, {start: startTime, end: endTime});
  const hours = Math.floor(timeToStart / 60);
  const minutesLeft = timeToStart % 60;

  const hoursWithHalfs = Math.round(timeToStart / 30) / 2;

  const hoursWithHalfsText = t('translation:HoursTimeUnitSuffix_full', {count: hoursWithHalfs});
  const hoursFormatted = t('translation:HoursTimeUnitSuffix_full', {count: hours});
  const minutesFormatted =
    minutesLeft === 0 ? '' : ` ${t('translation:MinutesTimeUnitSuffix_full', {count: minutesLeft})}`;
  const timeToStartFormatted = t('translation:MinutesTimeUnitSuffix_full', {count: timeToStart});

  const isTomorrow = !isSameDay(time, startTime); // Note: this works because we check 0 < dayDiff <= 1
  const relativeTime = isTomorrow
    ? t('meeting:MeetingTomorrow')
    : hours >= 2
    ? t('meeting:MeetingStartsIn', {formatedTime: hoursWithHalfsText})
    : hours >= 1
    ? t('meeting:MeetingStartsIn', {formatedTime: `${hoursFormatted}${minutesFormatted}`})
    : timeToStart > 0
    ? t('meeting:MeetingStartsIn', {formatedTime: timeToStartFormatted})
    : null;

  return {
    isOngoing,
    label: t(isOngoing ? 'meeting:CurrentMeeting' : 'meeting:UpcomingMeeting'),
    countdown: relativeTime,
  };
};
